import Vue from "vue"
import { ActionTree, MutationTree } from "vuex"

import Lang from "~/types/lang"
import UserAccount from "~/types/userAccount"
import { UserState } from "~/store/user"

export const state = () => ({
  accounts: [] as UserAccount[],
  locale: "en" as Lang,
  locales: ["en", "fr"] as Lang[],
})
export type RootState = ReturnType<typeof state>

export const mutations: MutationTree<RootState> = {
  SET_LANG(state, locale: Lang) {
    if (state.locales.includes(locale)) state.locale = locale
  },
  SET_ACCOUNTS(state, accounts: UserAccount[]) {
    Vue.set(state, "accounts", accounts)
  },
  REMOVE_ACCOUNT_BY_ID(state, accountId: number) {
    const index = state.accounts.findIndex((e) => e.pk === accountId)

    if (index > 0) state.accounts.splice(index, 1)
  },
}

export const actions: ActionTree<RootState, RootState> = {
  async nuxtServerInit({ dispatch, commit }): Promise<void> {
    await dispatch("csrf/FETCH")
    await dispatch("USER_LOAD")
    commit(
      "payin/payment_method/paypal/SET_CLIENT_ID",
      process.env.PAYPAL_V2_ID
    )
    return dispatch("ACCOUNTS_LOAD")
  },
  async ACCOUNTS_LOAD({ commit }): Promise<void> {
    try {
      const resp = await this.$axios.$get("/auth/switch/")

      commit("SET_ACCOUNTS", resp)
    } catch (err) {
      console.error(err)
    }
  },
  USER_LOAD({ dispatch }): Promise<UserState | void> {
    return new Promise((resolve) => {
      dispatch("user/LOAD")
        .then((user: UserState) => {
          resolve(user)
        })
        .catch(() => {
          resolve()
        })
    })
  },
}
